import { render } from "./ModalPenName.vue?vue&type=template&id=b996ca2e&scoped=true"
import script from "./ModalPenName.vue?vue&type=script&lang=js"
export * from "./ModalPenName.vue?vue&type=script&lang=js"

import "./ModalPenName.vue?vue&type=style&index=0&id=b996ca2e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b996ca2e"]])

export default __exports__